module.exports = __webpack_public_path__ + "img/t_4.358e8f9b.jpg";